import React from "react";
import "./MerchantDashboard.css";
import PayoutChart from "./PayoutChart";
import { maskValue } from "..";
import { useSelector } from "react-redux";

function ThirdSection({ payoutStatistic }) {
  const showValues = useSelector((s) => s.userReducer.showValues);

  let withdrawalAmount = payoutStatistic?.payoutAmount || 0;
  let commission = payoutStatistic?.payoutTotalComission || 0;
  let initiate = payoutStatistic?.payoutOutProcessing || 0;
  let reconAmounts = payoutStatistic?.reconAmount || 0;
  let reconPenaltys = payoutStatistic?.reconPenality || 0;

  let netPayout = withdrawalAmount + commission + reconAmounts + reconPenaltys;
  return (
    <div>
      <div className="second-section">
        <div className="settlement-wallet box-back">
          <div>
            <p className="wallet-head heading-new">Payout Breakup</p>
            <p className="sub-heading-new">
              ₹{" "}
              {maskValue(
                Intl.NumberFormat("en-US", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                }).format(netPayout),
                showValues
              )}
            </p>
          </div>

          <div className="normal-section">
            <p className="normal-font">
              <span className="heading-new">Withdrawal Amount :</span>
              <span className="price">
                ₹{" "}
                {maskValue(
                  Intl.NumberFormat("en-US", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  }).format(withdrawalAmount),
                  showValues
                )}
              </span>
            </p>
          </div>
          <div className="normal-section">
            <p className="normal-font">
              <span className="heading-new">Commission :</span>

              <span className="price">
                + ₹{" "}
                {maskValue(
                  Intl.NumberFormat("en-US", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  }).format(commission),
                  showValues
                )}
              </span>
            </p>
          </div>
          <div className="normal-section">
            <p className="normal-font">
              <span className="heading-new">Reconciliation Amount :</span>

              <span className="price">
                {" "}
                + ₹{" "}
                {maskValue(
                  Intl.NumberFormat("en-US", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  }).format(reconAmounts),
                  showValues
                )}
              </span>
            </p>
          </div>
          <div className="normal-section">
            <p className="normal-font">
              <span className="heading-new">Reconciliation Penalty :</span>

              <span className="price">
                {" "}
                + ₹{" "}
                {maskValue(
                  Intl.NumberFormat("en-US", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  }).format(reconPenaltys),
                  showValues
                )}
              </span>
            </p>
          </div>
          <div className="normal-section  line-data">
            <p className="normal-font">
              <span className="">Net Payout :</span>
              <span className="price">
                {" "}
                ₹{" "}
                {maskValue(
                  Intl.NumberFormat("en-US", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  }).format(netPayout),
                  showValues
                )}
              </span>
            </p>
          </div>
        </div>
        {payoutStatistic && (
          <div className="chart-div settlement-wallet box-back">
            <PayoutChart payoutStatistic={payoutStatistic} />
          </div>
        )}
      </div>
    </div>
  );
}

export default ThirdSection;
